module.exports = __webpack_public_path__ + "media/mypage/images/bg_service-86111967c3b8272e5705d4cba7356ed8.jpg";